import { NumberCons, StringConst } from 'src/app/constants/const';

export class CustomPaginatorEvent {
    offset: number;
    limit: number;
    constructor() {
        this.offset = NumberCons.zero;
        this.limit = NumberCons.zero;
    }
}
export class SearchValue {
    value: string;
    date: Date;
    constructor(value: string) {
        this.value = value;
        this.date = new Date();
    }
}

export class GeneralSearchQueryParams {
    itemCode = '';
    catalog = '';
}
